import { UserInfo } from '../types';
import { Message, RecommendParams, RecordMessage } from '../dataType';
import { botAvatar } from '../hooks/useConfig';
import transformContent from './transformContent';

/**
 * 把推荐文本使用参数转换
 * @param content 要转换的文本
 * @param params 参数列表
 * @returns 转换后的文本
 */
export const replaceRecommendLabel = (content: string, params: RecommendParams): string => {
  // 使用正则表达式匹配 {{key.name}}
  const regex = /\{\{([^{}]+)\}\}/g;
  return content.replace(regex, (match, key) => {
    // 解析参数名和属性名
    const [paramName, propName] = key.split('.');
    const values = params[paramName] as any[];
    if (values && values.length) {
      return values.map(item => item[propName]).join('、');
    }

    return '';
  });
};

export const recordToMessage = <T>(record: RecordMessage<T>, userInfo: UserInfo): Message<T> => {
  const isBot = record.chatType === 'botReply';
  if (isBot) {
    const fn = transformContent[record.wsType!];
    const data = fn?.(record.wsJson) || {
      content: null
    };
    return {
      id: record.id,
      userId: 0,
      avatar: botAvatar,
      status: 'success',
      type: record.wsType!,
      tag: record.tag,
      intentCode: record.intentCode,
      ...data,
      isRecord: true,
      createTime: record.createTime
    };
  }
  return {
    id: record.id,
    userId: userInfo.userId,
    avatar: userInfo.avatar,
    content: record.input as T,
    status: 'success',
    type: 'ai.sendText',
    isRecord: true,
    createTime: record.createTime
  };
};
